// manage ui state
// darkmode
// sidebar
import { defineStore, storeToRefs } from "pinia";
import { ref } from "vue";

export const useUIStore = defineStore(
    "ui",
    () => {
        const darkMode = ref<boolean>(false);
        const showSidebar = ref<boolean>(true);
        const sidebarWidth = ref<number>(180);
        // Wording register on the reconcile page: plain language ("Keep main")
        // vs technical ("Take main (theirs)", branch refs, conflict kinds).
        const reconcileWording = ref<"plain" | "technical">("plain");

        const toggleDarkMode = (newValue?: boolean) => {
            if (newValue === undefined) {
                newValue = !darkMode.value;
            }
            if (newValue) {
                document
                    .querySelector("html")!
                    .classList.add("dark-mode", "sl-theme-dark");
            } else {
                document
                    .querySelector("html")!
                    .classList.remove("dark-mode", "sl-theme-dark");
            }
            darkMode.value = newValue;
        };

        const toggleSideBar = () => {
            showSidebar.value = !showSidebar.value;
        };

        return {
            darkMode,
            toggleDarkMode,
            showSidebar,
            sidebarWidth,
            reconcileWording,
            toggleSideBar,
        };
    },
    {
        // persist this store in localStorage
        persist: {
            storage: localStorage,
            afterHydrate: (ctx) => {
                if (ctx.store.darkMode === true) {
                    ctx.store.toggleDarkMode(true);
                }
            },
        },
    }
);

export const useUIManager = () => storeToRefs(useUIStore());
